export const userTypeConstants = Object.freeze({
  CLIENT: 'Client',
  LSL_ADMIN: 'LSLAdmin',
  CLIENT_ADMIN: 'ClientAdmin',
})
